var _rect, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifiedBadgeSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#136B65"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99731 15.2154C7.18489 17.4127 9.37399 19.0037 11.9636 19.3926L9.58138 21.8267C9.06306 22.3563 8.80338 22.6213 8.58388 22.7131C8.08357 22.9219 7.52799 22.7432 7.26481 22.2884C7.14943 22.0888 7.11363 21.7286 7.04168 21.0089C7.00105 20.6024 6.98055 20.3992 6.91887 20.229C6.78083 19.8479 6.49107 19.5513 6.11824 19.4102C5.95163 19.3472 5.75201 19.3268 5.35418 19.2853C4.64964 19.2117 4.29699 19.1748 4.10167 19.0568C3.65679 18.7879 3.48219 18.2207 3.68636 17.7097C3.77606 17.4854 4.03513 17.2199 4.55355 16.6902L5.99731 15.2154Z",
    fill: "url(#paint0_linear_677_5249)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8496 16.6902C22.368 17.2199 22.627 17.4854 22.7167 17.7097C22.9209 18.2208 22.7464 18.7879 22.3014 19.0568C22.1061 19.1748 21.7535 19.2117 21.0489 19.2853C20.6514 19.3268 20.4523 19.3473 20.2858 19.4102C19.9128 19.5513 19.6223 19.8478 19.4842 20.229C19.4226 20.3992 19.4021 20.6024 19.3614 21.0089C19.2895 21.7286 19.2537 22.0888 19.1383 22.2884C18.8751 22.7432 18.3195 22.9219 17.8192 22.7131C17.5998 22.6213 17.3408 22.3562 16.8227 21.8267L14.4395 19.3926C17.0291 19.0037 19.2182 17.4127 20.4058 15.2154L21.8496 16.6902Z",
    fill: "url(#paint1_linear_677_5249)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.202 4.7998C16.9132 4.80003 19.9221 7.76904 19.9221 11.4315C19.9221 15.0939 16.9132 18.0629 13.202 18.0631C9.49065 18.0631 6.48199 15.094 6.48199 11.4315C6.48199 7.7689 9.49065 4.7998 13.202 4.7998ZM13.202 8.58932C12.9293 8.58932 12.7465 8.9122 12.3817 9.55798L12.287 9.72544C12.1835 9.9087 12.1315 10.0008 12.0508 10.0613C11.97 10.1216 11.8693 10.1441 11.6683 10.189L11.4845 10.2297C10.7764 10.3878 10.4222 10.4674 10.3379 10.7348C10.254 11.0021 10.4956 11.2806 10.9783 11.8376L11.103 11.9819C11.2402 12.1403 11.3093 12.2198 11.3401 12.3178C11.3709 12.4156 11.3599 12.5213 11.3392 12.7323L11.3205 12.9247C11.2474 13.6682 11.2115 14.0398 11.432 14.2051C11.6526 14.3704 11.9839 14.2197 12.647 13.9183L12.8186 13.8406C13.0071 13.755 13.1021 13.712 13.202 13.712C13.3018 13.7121 13.3963 13.7551 13.5845 13.8406L13.7561 13.9183C14.4193 14.2197 14.7505 14.3704 14.9711 14.2051C15.1917 14.0399 15.1557 13.6682 15.0827 12.9247L15.0639 12.7323C15.0432 12.5213 15.0322 12.4156 15.063 12.3178C15.0938 12.2198 15.1629 12.1403 15.3002 11.9819L15.4248 11.8376C15.9075 11.2806 16.1491 11.0021 16.0652 10.7348C15.9809 10.4674 15.6268 10.3878 14.9186 10.2297L14.7348 10.189C14.5338 10.1441 14.4331 10.1217 14.3523 10.0613C14.2716 10.0008 14.2196 9.90873 14.1161 9.72544L14.0214 9.55798C13.6568 8.91256 13.4745 8.58966 13.202 8.58932Z",
    fill: "url(#paint2_linear_677_5249)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_677_5249",
    x1: 6.96593,
    y1: 9.81152,
    x2: 22.8521,
    y2: 27.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_677_5249",
    x1: 6.96593,
    y1: 9.81152,
    x2: 22.8521,
    y2: 27.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_677_5249",
    x1: 6.96593,
    y1: 9.81152,
    x2: 22.8521,
    y2: 27.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedBadgeSmall);
export default __webpack_public_path__ + "static/media/VerifiedBadgeSmall.22a8ffad88afdbde421622a602631ac6.svg";
export { ForwardRef as ReactComponent };